import { Box, H3, Icon, Link, Separator, Text } from '@betterment/samba-react';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { DateRangeOption } from '../../../../graphql/schema';
import { DateRangeFilter } from '../../../shared/date-range-filter/DateRangeFilter';
import { PerformanceAccountQuery } from '../../graphql/performanceAccount.generated';

type HeaderProps = {
  dateRangeOption: DateRangeOption;
  account: PerformanceAccountQuery['performance']['accounts'][0];
  setDateRangeOption: (option: DateRangeOption) => void;
  returnToUrl: string;
  returnToLabel: string;
};

export const Header = ({ dateRangeOption, account, setDateRangeOption, returnToUrl, returnToLabel }: HeaderProps) => {
  const {
    icon: accountIcon,
    name: accountName,
    envelope: { purpose },
  } = account;
  const name = purpose?.name || accountName;
  const icon = purpose?.image || accountIcon;

  return (
    <Box css={{ paddingY: 'space.300' }}>
      <Link
        href={returnToUrl}
        css={{ display: 'flex', alignItems: 'center', gap: 'space.100', marginBottom: 'space.200' }}
      >
        <Icon name="CaretLeft" size="small" color="icon" />
        <Text color="text">{returnToLabel}</Text>
      </Link>
      <Box css={{ display: 'flex', gap: 'space.150' }}>
        <Box css={{ alignSelf: 'center', width: 'size.450', height: 'size.450', flexShrink: 0 }}>
          <ThemedImage themedAsset={icon} alt={accountName} />
        </Box>
        <Box css={{ whiteSpace: 'nowrap' }}>
          <H3 variant="title200">{name}</H3>
          {purpose && (
            <Text variant="text50" color="text">
              {accountName}
            </Text>
          )}
        </Box>
      </Box>
      <Separator css={{ fullWidthWithInset: 'space.0', marginTop: 'space.300', marginBottom: 'space.300' }} />
      <DateRangeFilter onChange={setDateRangeOption} selected={dateRangeOption} />
    </Box>
  );
};
